import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import { entranceGuard, queryUserTreeList } from '@api/api';
import SelectOnlineSiteListModal from "../../assets/SelectOnlineSiteListModal";
import { duplicateCheck } from "../../../api/api";
export default {
  name: 'EntranceGuardModal',
  components: {
    SelectOnlineSiteListModal: SelectOnlineSiteListModal
  },
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        cardNumber: {
          rules: [{
            required: true,
            message: '请输入卡号!'
          }, {
            validator: this.validateDictCode
          }]
        },
        password: {
          rules: [{
            required: true,
            message: '请输入密码!'
          }, {
            validator: this.validateDictCode2
          }]
        }
      },
      url: {
        add: '/sys/entrance/guard',
        edit: '/sys/entrance/guard',
        issueRpc: '/comm/api/issueRpc',
        deleteRpc: '/comm/api/deleteRpc'
      },
      disableSubmit: false,
      // 人员信息
      userTree: [],
      type: '',
      selectedSite: [[]],
      siteIds: [],
      tableData: [],
      addNum: 1,
      index: 0,
      oldCard: '',
      oldPassword: '',
      colorInfo: {
        1: {
          color: 'green',
          text: '已下发'
        },
        2: {
          color: 'gold',
          text: '未下发'
        },
        6: {
          color: 'red',
          text: '系统故障'
        }
      }
    };
  },
  created: function created() {},
  methods: {
    validateDictCode: function validateDictCode(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'sys_entrance_guard',
        fieldName: 'card_number',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback(res.message);
        }
      });
    },
    validateDictCode2: function validateDictCode2(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'sys_entrance_guard',
        fieldName: 'password',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback(res.message);
        }
      });
    },
    handleAdd_: function handleAdd_() {
      var that = this;

      if (that.addNum == 0) {
        that.addNum = 3;
      }

      for (var i = 0; i < that.addNum; i++) {
        var item = {
          siteId: null,
          device1: {
            name: '',
            assetCode: '',
            checked: false
          },
          device2: {
            name: '',
            assetCode: '',
            checked: false
          },
          device3: {
            name: '',
            assetCode: '',
            checked: false
          },
          device4: {
            name: '',
            assetCode: '',
            checked: false
          },
          device5: {
            name: '',
            assetCode: '',
            checked: false
          },
          selectedSite: []
        };
        this.tableData.push(item);
      }
    },
    handleNumChange: function handleNumChange(value) {
      this.addNum = value;
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.userTree = [];
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    selectSite: function selectSite(index) {
      this.index = index;
      this.$refs.SelectOnlineSiteListModal.add(this.selectedSite, this.siteIds);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSite = [];
      this.siteIds = [];
      this.tableData[this.index].selectedSite = [];

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.getEntranceGuard(siteList[i].id);
        this.siteIds = siteList[i].id;
        this.tableData[this.index].siteId = siteList[i].id;
        this.tableData[this.index].selectedSite.push(siteList[i].name);
      }
    },
    getEntranceGuard: function getEntranceGuard(siteId) {
      var _this2 = this;

      var index = this.index;
      entranceGuard(siteId).then(function (res) {
        if (res.success) {
          res.result.forEach(function (e, i) {
            _this2.tableData[index]['device' + (i + 1)] = Object.assign({}, _this2.tableData[index]['device' + (i + 1)], e);
          });
        }
      });
    },

    /* 编辑回显*/
    editGuard: function editGuard(v, arr) {
      this.tableData.forEach(function (e) {
        var _loop = function _loop(key) {
          if (key.search('device') > -1) {
            console.log(arr.find(function (f) {
              return f.assetCode == e[key].assetCode;
            }));

            if (arr.find(function (f) {
              return f.assetCode == e[key].assetCode;
            }) && e[key].status) {
              e[key].checked = true;
            }
          }
        };

        for (var key in e) {
          _loop(key);
        }
      });
    },
    add: function add(type) {
      this.type = type;
      this.edit({});
    },
    edit: function edit(record) {
      var _this3 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadTree();
      this.selectedSite = [];
      this.siteIds = [];
      this.tableData = [];
      this.oldCard = '';
      this.oldPassword = '';

      if (this.model.id != null) {
        this.oldCard = this.model.cardNumber;
        this.oldPassword = this.model.password;
      }

      this.$nextTick(function () {
        _this3.form.setFieldsValue(pick(_this3.model, 'userId', 'siteId', 'cardNumber', 'password', 'remark', 'createBy', 'createTime', 'updateBy', 'updateTime')); //时间格式化


        _this3.form.setFieldsValue({
          createTime: _this3.model.createTime ? moment(_this3.model.createTime) : null
        });

        _this3.form.setFieldsValue({
          updateTime: _this3.model.updateTime ? moment(_this3.model.updateTime) : null
        });
      });
      this.getMstate(this.model.id);
    },

    /* 获取站点门禁设备状态*/
    getMstate: function () {
      var _getMstate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _this4 = this;

        var data, list, arr;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return httpAction('sys/entrance/guard/item/' + id, {}, 'get');

              case 2:
                data = _context.sent;
                console.log(data);
                list = data.result.map(function (e, v) {
                  /* 初始化 this.tableData*/
                  _this4.handleAdd_();
                  /* 站点回显 */


                  _this4.tableData[v].selectedSite = [];
                  _this4.tableData[v].siteId = e.siteId;

                  _this4.tableData[v].selectedSite.push(e.siteName);
                  /* 选中的门禁收集 */


                  e.siteDeviceBanVoList.forEach(function (ee, vv) {
                    _this4.tableData[v]['device' + (vv + 1)] = Object.assign({}, _this4.tableData[v]['device' + (vv + 1)], ee);
                  });
                  return e.siteDeviceBanVoList;
                });
                arr = [];
                list.forEach(function (e) {
                  arr = [].concat(_toConsumableArray(arr), _toConsumableArray(e));
                });
                data.result.forEach(function (e, i) {
                  _this4.editGuard(i, arr);
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getMstate(_x) {
        return _getMstate.apply(this, arguments);
      }

      return getMstate;
    }(),
    close: function close() {
      this.type = '';
      this.$emit('close');
      this.visible = false;
    },
    determine: function determine() {
      var _this5 = this;

      if (this.model.id != null) {
        var that = this;
        var list = {
          cardNumber: this.oldCard,
          password: this.oldPassword,
          instructionsType: '-Delete'
        };
        httpAction(this.url.issueRpc, list, 'post').then(function (res) {
          if (res.success) {
            _this5.handleOk(); // that.$notification.success({ message: res.message })

          } else {
            that.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.handleOk();
      }
    },
    handleOk: function handleOk() {
      var _this6 = this;

      var list = [];
      this.tableData.forEach(function (e) {
        for (var key in e) {
          if (key.search('device') > -1 && e[key].checked) {
            list.push({
              siteId: e[key].siteId,
              assetId: e[key].assetId
            });
          }
        }
      });
      console.log(list); // return

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this6.model.id) {
            httpurl += _this6.url.add;
            method = 'post';
          } else {
            httpurl += _this6.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this6.model, values, {
            entranceGuardItemList: list
          });
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this6.InstructionIssuance(formData.cardNumber, formData.password);

              that.$message.success(res.message);
              that.$emit('ok');
              that.close();
            } else {
              that.$message.warning(res.message);
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    InstructionIssuance: function InstructionIssuance(value1, value2) {
      var that = this;
      var list = {
        cardNumber: value1,
        password: value2,
        instructionsType: '-Issued'
      };
      var method = 'post';
      httpAction(this.url.issueRpc, list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    }
  }
};